import React from 'react';

var MinusIcon = function MinusIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "46",
    viewBox: "0 0 46 46"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeWidth: "2",
    d: "M12.268 23h21.464"
  })));
};

export default MinusIcon;